import { IMG_PATH, IMG_ENDING,IMG_PATH_MINIFIED } from "../model/Config";

export function getImgSrcOfData(data) {
  if (data.img) {
    return getImgSrcOfImg(data.img,false);
  }
}
export function getMiniSrcOfData(data){
  if (data.img) {
    return getImgSrcOfImg(data.img,true);
  }
}
export function getImgSrcOfImg(img, miniVersion) {
  if (img) {
    let path = miniVersion?IMG_PATH_MINIFIED:IMG_PATH
    let imgSrc =  path + img + IMG_ENDING;

    if (img.indexOf(".") > -1) {
      imgSrc = path + img;
    }
    return imgSrc;
  }
}
